import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink.vue';
var TYPES = {
  primary: 'primary',
  secondary: 'secondary'
};
export default {
  name: 'Tag',
  components: {
    MdmLink: MdmLink
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary'].includes(value);
      }
    },
    light: {
      type: Boolean,
      default: false
    },
    isNuxtLink: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    srcset: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    }
  },
  computed: {
    colorStyle: function colorStyle() {
      return {
        '--tag-color': this.color || '#C4A181'
      };
    },
    types: function types() {
      return TYPES;
    }
  }
};